// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthCapability\ApiBerthCapability.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthCapabilityAssignment, BerthCapabilityAssignmentData, BerthCapabilityAssignmentOptions } from 'data/models/BerthCapabilityAssignment';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';

// BerthCapabilityData is the class that BerthCapability serializes to/from
export interface BerthCapabilityData {
    Id : number;
    Url : string | null;
	
    Berths : BerthCapabilityAssignmentData[] | null;
    Domain : DomainData | null;
    DomainId : number;
	
    Active : boolean;
    Guid : /* GUID */ string;
    Name : string;
    Order : number;
}

// BerthCapabilityOptions is the class which may be passed to the BerthCapability constructor to define optional initial data values
export interface BerthCapabilityOptions {
    Id : number;
    Url? : string | null;
	
    Berths? : BerthCapabilityAssignmentOptions[] | null;
    Domain? : DomainOptions | null;
    DomainId? : number;
	
    Active? : boolean;
    Guid? : /* GUID */ string;
    Name? : string;
    Order? : number;
}

export class BerthCapability {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berths : SDataArray<BerthCapabilityAssignment>;
    public Domain : DataSignal<Domain | null>;
    public DomainId : DataSignal<number>;
	
    public Active : DataSignal<boolean>;
    public Guid : DataSignal<string>;
    public Name : DataSignal<string>;
    public Order : DataSignal<number>;

    constructor();
    constructor(data : BerthCapabilityOptions);
    constructor(data: BerthCapabilityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berths = SArray<BerthCapabilityAssignment>([]);
        this.Domain = S.value<Domain | null>(null);
        this.DomainId = jsonableObservable(S.value<number>(data && data.DomainId !== undefined ? data.DomainId : 0));
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
    }

    static key(obj : BerthCapability) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthCapabilityOptions) {
        return obj.Id;
    }

    static update(obj : BerthCapability, data : BerthCapabilityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.DomainId !== undefined) obj.DomainId(data.DomainId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Order !== undefined) obj.Order(data.Order);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthCapability.ts